import { create } from 'zustand';

const useProductStore = create((set, get) => ({
    products: [],
    currentProduct: null,
    isLoading: true,
    setProducts: (products) => set({ products }),
    setCurrentProduct: (product) => set({ currentProduct: product }),
    setIsLoading: (isLoading) => set({ isLoading })
}));

export default useProductStore;
